var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"c-advanced-search__rule",class:{ 'c-advanced-search__rule--union': _vm.union }},_vm._l((_vm.chips),function(chip){return _c(chip.component,_vm._g(_vm._b({key:chip.key,tag:"component"},'component',chip.bind,false),chip.on))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }